import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * R1 — `/groups/{slug}/students/quiz-submissions` is a redirect, not a screen.
 *
 * Legacy's tab template is a 0-byte file
 * (`buddypress/groups/single/students/quiz-submissions.php`) and
 * `student-submission-actions.php:20-29 bp_nav_redirect` 302s the bare subnav to
 * `.../quizzes` before anything renders. WordPress then 301s to the trailing
 * slash, so both spellings have to resolve; the router's
 * `trailingSlash: 'always'` (`router.ts:13`) folds them onto this one route.
 *
 * It redirects from `beforeLoad` rather than from a component effect — unlike
 * the guards on `$groupName.admin.tsx` and `$groupName.students.tsx`, the answer
 * needs no payload, so bouncing before the subtree mounts avoids a frame of
 * empty tab body.
 */
export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/groups/$groupName/students/quiz-submissions/quizzes/',
      params: { groupName: params.groupName },
      replace: true,
    });
  },
});
